import { Outlet, useParams } from 'react-router-dom';
import { useWorkspaceStore } from '@/stores/workspace-store';

export function WorkspaceLayout() {
  const { id } = useParams<{ id: string }>();
  const workspaces = useWorkspaceStore((s) => s.workspaces);
  const workspace = workspaces.find((w) => w.id === id);

  if (!workspace) {
    return (
      <div className="text-muted-foreground flex min-h-screen items-center justify-center">
        Workspace not found.
      </div>
    );
  }

  return (
    <div className="bg-background flex h-screen w-full flex-col overflow-hidden">
      <Outlet />
    </div>
  );
}
